import React from 'react';

const CONTENT_TYPE_PROPERTY_NAME_PROPERTY: 'name' | 'machineName' = 'machineName';

export default function ContentTypePropertyName({ property }: { property: { machineName: string; name: string } }) {
  return <>{property[CONTENT_TYPE_PROPERTY_NAME_PROPERTY]}</>;
}
